import { filterBlank } from '../lists/filterEmpty';
import { getArray, type MergeInput } from '../lists/mergeArrays';
import { normalizeValue } from './normalizeValue';

export function normalizeValues<T extends string>(values: MergeInput<T | undefined>): T[] {
	// Condense to an array
	const merged = getArray(values);

	// Normalize all the values
	const normalized = merged.map(normalizeValue);

	// Remove any values that are blank
	return filterBlank(normalized);
}
